import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  TrainingGroupSkeleton,
  TrainingGroupAudit,
  TrainingGroupTrainingRequirementAudit
} from '../../+models/training-requirement-audit.model';

@Component({
  selector: 'sd-portal-training-group-audit-list',
  templateUrl: './training-group-audit-list.component.html',
  styleUrls: ['./training-group-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrainingGroupAuditListComponent implements OnInit {
  @Input() trainingGroupSkeletons: TrainingGroupSkeleton[];
  @Input() loading: boolean;
  @Input() audits: TrainingGroupAudit[];
  @Input() trainingGroupTrainingRequirementAudits: TrainingGroupTrainingRequirementAudit[];
  @Input() trainingGroupTrainingRequirementAuditLoading: boolean;

  @Output() opened = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();
  @Output() openedTrainingGroupTrainingRequirement = new EventEmitter<number>();
  @Output() nextTrainingGroupTrainingRequirementPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  onOpened(trainingGroupId: number) {
    this.opened.emit(trainingGroupId);
  }

  onNextPage(trainingGroupId: number) {
    this.nextPage.emit(trainingGroupId);
  }

  onOpenedTrainingGroupTrainingRequirement(trainingGroupTrainingRequirementId: number) {
    this.openedTrainingGroupTrainingRequirement.emit(trainingGroupTrainingRequirementId);
  }

  onNextTrainingGroupTrainingRequirementPage(trainingGroupTrainingRequirementId: number) {
    this.nextTrainingGroupTrainingRequirementPage.emit(trainingGroupTrainingRequirementId);
  }
}
